// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
Vue.use(ElementUI);

// ↓ 简化el-ui提示消息
Vue.prototype.showMES = (content, type = 'info')=>{
  ElementUI.Message.closeAll();
  ElementUI.Message({
		showClose: true,
		message: content,
		type: type,
		customClass: 'custom-el-message',
		duration: 4000
		// duration: 0
	});
};
// ↓ 简化el-ui询问框
Vue.prototype.showConfirm = opt => {
	opt.tip = opt.tip ? opt.tip : '确定删除?';
	opt.title = opt.title ? opt.title : '提示';
	ElementUI.MessageBox.confirm(opt.tip, opt.title, {
    customClass: 'self-msg-box',
    closeOnClickModal: false,
		confirmButtonText: opt.confirmButtonText || '确 定',
		cancelButtonText: opt.cancelButtonText || '取 消',
		type: 'warning'
	}).then(() => {
		// ↓ 点击询问框中的 确定
		opt.confirm && opt.confirm();
	}).catch(() => {
		// ↓ 点击询问框中的 取消
		opt.cancel && opt.cancel();
	});
};

import axios from 'axios';
import VueAxios from 'vue-axios';
/* ↓ axios 默认配置 */

axios.defaults.headers.post['Content-Type'] = 'application/json';

// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
// axios.defaults.headers.common['Content-Type'] = 'application/json'
// axios.defaults.headers.common['Access-Token'] = store.state.user['Access-Token']
Vue.use(VueAxios, axios);

/* ↓ 引入后台接口，全局调用 */
import Api from './lib/server.js';
Vue.prototype.Api = Api;

// const BaseURL_HXJ = process.env.API_ROOT_HXJ;
// const BaseURL_WK = process.env.API_ROOT_WK;

// Vue.prototype.BaseURL_HXJ = BaseURL_HXJ + 'Index/'; // 胡夏君接口
// Vue.prototype.BaseURL_WK = BaseURL_WK;              // 王魁接口

// window.BaseURL = BaseURL;

// Vue.prototype.BaseURL_H = BaseURL + 'Index/';
// ↓ 设置 axios 默认请求接口地址
// axios.defaults.baseURL = BaseURL + 'Index/';

/* ↓ 引入 globalFn.js 中的函数，挂载到Vue全局调用 */
import globalFn from './lib/globalFn.js';
Vue.prototype.globalFn = globalFn;

import router from './router/router.js';
import store from './store/store.js';

Vue.config.productionTip = false;

import VueMeta from 'vue-meta';
Vue.use(VueMeta);

// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts');
// 引入柱状图
require('echarts/lib/chart/bar');
// 引入提示框和标题组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
Vue.prototype.$echarts = echarts;

// // console.log('globalFn:',globalFn)
// /* eslint-disable no-new */
// // 请求拦截器
// axios.interceptors.request.use(
//   config => {
//     // 每次发送请求之前判断vuex中是否存在token
//     // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
//     // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
//     const token = store.state.token;
//     if(token && config.headers['Access-Token'] == token){
//       // console.log('config.headers ↓\n',config.headers);
//       return config;
//     };
//   },
//   error => {
//     return Promise.error(error);
//   }
// );

export default new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js